import styled from "@emotion/styled";
import { useEffect, useState } from "react";
import { Box, Select, MenuItem, FormControl } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { logOut } from "../api/client";
import { 
  DataPieIcon,
  DetectListIcon,
  //DetectPastIcon,
  LogOutIcon,
  ManagementIcon,
  NoticeIcon,
  SmallAdminIcon,
  SmallNokIcon,
  SmallRealAdminIcon,
  TracktorAndGlassIcon,
  TracktorIcon,
  SiteMapIcon,
  ShopZoneIcon,
 } from "../assets/icons/icons";
import { NongCallLogo3 } from "../assets/images/images";
import theme from "../theme";
import userStorage from "../utils/userStorage";
import UserDetailModal from "./userDetailModal/userDetailModal";
import UserModifyModal from "./userModifyModal/userModifyModal";
import { User, MemberDetail } from "../types/types";
import useGetNotice from "../hooks/useGetNotice";
import { NotificationBadge } from "./common/NotificationBadge";
import { HeaderUser } from "./headerUser";
import { useSystemSetting } from "../hooks/useSystemSetting";
import { useLocaleWithStorage, Locale, useI18n } from "../locales";
import { LanguageFlag } from "../assets/images/languageFlags";

const TopNav: React.FC<{ separator?: boolean }> = (props) => {
  const { separator } = props;

  const location = useLocation();
  const navigate = useNavigate();
  const user = userStorage.get();
  const { locale, setLocale } = useLocaleWithStorage();
  const { t } = useI18n();
  const [open, setOpen] = useState(false);
  const [detailData, setDetailData] = useState<MemberDetail>();
  const [openModify, setOpenModify] = useState(false);
  const [idx, setIdx] = useState(0);
  const [accessAll, setAccessAll] = useState(false); // area = 00000 / grade = 2
  const [accessAdmin, setAccessAdmin] = useState(false); // area = 11440/ grade = 2
  const systemSetting = useSystemSetting();

  const { data: newNoticeData } = useGetNotice(0, 0);

  const onClick = (path: string) => {
    navigate(`${path}`);
  };

  const userModalonPressNo = () => {
    setOpen(false);
  };
  const onClickModify = () => {
    setOpen(false);
    setOpenModify(true);
  };

  const onClickDetail = (el: User) => {
    setIdx(el.idx);
    setOpen(true);
  };

  const onPressNoModify = () => {
    setOpenModify(false);
  };

  const handleClick = () => {
    // 유저이름 클릭시
    if (user) {
      onClickDetail(user);
    }
    return;
  };

  const hadleLogout = () => {
    const result = window.confirm(`로그아웃하시겠습니까 ?`);
    if (result) {
      logOut();
      navigate(`/login`, { replace: true });
    } else if (!result) {
      return;
    }
  };

  useEffect(() => {
    if (user) {
      if (user.area === "00000" && user.grade === 2) {
        setAccessAll(true);
        return;
      }
      if (user.area === "11440" && user.grade === 2) {
        setAccessAdmin(true);
        return;
      }
    }
  }, [user]);

  return (
    <Box
      sx={{
        pl: "30px",
        pt: "20px",
        pr: "30px",
        pb: "20px",
        borderBottom: separator
          ? `3px solid ${theme.color.neutral_200}`
          : "none",
        backgroundColor: theme.color.white,
        display: "flex",
        alignItems: "center",
        maxHeight: "76px",
        /*maxWidth: "1440px",*/
        margin: "0 auto",
      }}
    >
      <LogoWrapper
        onClick={() => onClick("/")}
        style={{ marginRight: "30px" }}
      >
        <NongCallLogo3 width={92} height={36} />
      </LogoWrapper>

      <HeaderItems>
        {/* 관제 드롭 다운 
        <HeaderItemContainer
          active={location.pathname.includes("/control")}
        >
          {`사고 관제`}
          <HeaderItemBox>
            <HeaderItem
              key={"사고 관제"}
              active={location.pathname === "/control"}
              onClick={() => onClick("/control")}
            >
              {`사고 관제`}
            </HeaderItem>
            <HeaderItem
              key={"과거 감지내역 조회"}
              active={location.pathname === "/control/past"}
              onClick={() => onClick("/control/past")}
            >
              {`과거 감지내역 조회`}
            </HeaderItem>
          </HeaderItemBox>
        </HeaderItemContainer>
        */}

        
        {/*<IconWrapper>
          <TracktorIcon
          width={10}
          height={10}
          />
      </IconWrapper>*/}
        <HeaderItem
          key={"사고 관제"}
          active={location.pathname === "/"/*"/control"*/}
          onClick={() => onClick("/"/*"/control"*/)}
        >
          <TracktorIcon
          width={15}
          height={15}
          fill={theme.color.neutral_500}
          />
          <NavText>{t.navigation.accidentControl}</NavText>
        </HeaderItem>
        {/* <HeaderItem
          key={"과거 감지내역 조회"}
          active={location.pathname === "/control/past"}
          onClick={() => onClick("/control/past")}
        >
          <DetectPastIcon
              width={15}
              height={15}
              fill={theme.color.neutral_500}
            />
          <NavText>과거 감지내역 조회</NavText>
        </HeaderItem> */}

        {/* 조회 드롭 다운 
        <HeaderItemContainer
          active={
            location.pathname.includes("/detect-list") ||
            location.pathname.includes("/mobile-list") ||
            location.pathname.includes("/healthCheck")
          }
        >
          {`조회`}
          <HeaderItemBox>
            <HeaderItem
              key={"감지내역 조회"}
              active={location.pathname.includes("/detect-list")}
              onClick={() => onClick("/detect-list")}
              isDrop={true}
            >
              <Button
                onClick={() => onClick("/detect-list")}
              >{`감지내역 조회`}</Button>
            </HeaderItem>
            <HeaderItem
              key={"농기계 상세조회"}
              active={location.pathname.includes("/mobile-list")}
              onClick={() => onClick("/mobile-list")}
              isDrop={true}
            >
              <Button
                onClick={() => onClick("/mobile-list")}
              >{`농기계 상세조회`}</Button>
            </HeaderItem>
          </HeaderItemBox>
        </HeaderItemContainer>
        */}
        <HeaderItem
          key={"감지내역 조회"}
          active={location.pathname.includes("/detect-list")}
          onClick={() => onClick("/detect-list")}
        >
          <DetectListIcon
              width={15}
              height={15}
              fill={theme.color.neutral_500}
            />
          <NavText>{t.navigation.detectionHistory}</NavText>
        </HeaderItem>

        <HeaderItem
          // key={"감지내역 통계"}
          key={"통계"}
          active={location.pathname.includes("/stastics")}
          onClick={() => onClick("/stastics")}
        >
          <DataPieIcon
              width={15}
              height={15}
              fill={theme.color.neutral_500}
            />
          {/* {`감지내역 통계`} */}
          <NavText>{t.navigation.statistics}</NavText>
        </HeaderItem>

        <HeaderItem
          key={"공지사항"}
          active={location.pathname.includes("/notice")}
          onClick={() => onClick("/notice")}
        >
          <NoticeIcon
              width={15}
              height={15}
              fill={theme.color.neutral_500}
            />
          <NavText>{t.navigation.notice}</NavText>
          {newNoticeData && newNoticeData.list.length > 0 && (
            <NotificationBadge
              width={"6px"}
              height={"6px"}
              top={"20px"}
              right={"-6px"}
            />
          )}
        </HeaderItem>

        {/* 관리 드롭 다운 */}
        <HeaderItemContainer
          active={
            location.pathname.includes("/admin") ||
            location.pathname.includes("/customer") ||
            location.pathname.includes("/nok")
          }
        >
          <ManagementIcon
            width={15}
            height={15}
            fill={theme.color.neutral_500}
          />
          <NavText>{t.navigation.management}</NavText>
          <HeaderItemBox>
            <HeaderItem
                key={"농기계 관리"}
                active={location.pathname.includes("/mobile-list")}
                onClick={() => onClick("/mobile-list")}
                emptyCircle={true}
              >
              <TracktorAndGlassIcon
                  width={15}
                  height={15}
                  fill={theme.color.neutral_500}
                />
              <NavText>{t.navigation.farmMachineryManagement}</NavText>
            </HeaderItem>
            <HeaderItem
              style={
                accessAll || accessAdmin
                  ? { display: "block" }
                  : { display: "none" }
              }
              key={"사용자 계정 관리"}
              active={location.pathname.includes("/admin")}
              isDrop={true}
              onClick={() => onClick("/admin")}
            >
              <Button onClick={() => onClick("/admin")}>
                <SmallRealAdminIcon
                    width={15}
                    height={15}
                    fill={theme.color.neutral_500}
                  />
              <NavText>{t.navigation.userAccountManagement}</NavText>
              </Button>
            </HeaderItem>
            <HeaderItem
              key={"소유자 관리"}
              active={location.pathname.includes("/customer")}
              isDrop={true}
              onClick={() => onClick("/customer")}
            >
              <Button onClick={() => onClick("/customer")}>
                <SmallAdminIcon
                  width={15}
                  height={15}
                  fill={theme.color.neutral_500}
                />
              <NavText>{t.navigation.ownerManagement}</NavText>
              </Button>
            </HeaderItem>
            <HeaderItem
              key={t.navigation.additionalRecipientManagement}
              active={location.pathname.includes("/nok")}
              onClick={() => onClick("/nok")}
              isDrop={true}
            >
              <Button onClick={() => onClick("/nok")}>
                <SmallNokIcon
                  width={15}
                  height={15}
                  fill={theme.color.neutral_500}
                />
              <NavText>{t.navigation.additionalRecipientManagement}</NavText>
              </Button>
            </HeaderItem>
          </HeaderItemBox>
        </HeaderItemContainer>

        {/* 임대사업소 안전구역 — 인플랩 관리자(00000 / 2)만 */}
        {accessAll && (
          <HeaderItem
            key={"임대사업소 안전구역"}
            active={location.pathname.includes("/shop-zone")}
            onClick={() => onClick("/shop-zone")}
          >
            <ShopZoneIcon
              width={15}
              height={15}
              fill={theme.color.neutral_500}
            />
            <NavText>{t.navigation.shopZone}</NavText>
          </HeaderItem>
        )}

        {/* 사이트맵 */}
        <HeaderItem
          key={"사이트맵"}
          active={location.pathname.includes("/sitemap")}
          onClick={() => onClick("/sitemap")}
        >
          <Button onClick={() => onClick("/sitemap")}>
            <SiteMapIcon
              width={15}
              height={15}
              fill={theme.color.neutral_500}
            />
            <NavText>{t.navigation.sitemap}</NavText>
          </Button>
        </HeaderItem>
      </HeaderItems>

      <OptionWrapper>
        {/* 언어 선택 셀렉박스 */}
        {false && (
          <LanguageSelectWrapper>
            <LanguageSelectFormControl size="small">
            <LanguageSelectDisplay>
              <LanguageFlag locale={locale} width={18} height={12} />
            </LanguageSelectDisplay>
            <LanguageSelectMUI
              value={locale}
              onChange={(e) => setLocale(e.target.value as Locale)}
              renderValue={() => ""}
              sx={{
                "& .MuiSelect-select": {
                  padding: "4px 26px 4px 0",
                  fontSize: "12px",
                },
                "& .MuiSvgIcon-root": {
                  fontSize: "16px",
                },
              }}
              MenuProps={{
                PaperProps: {
                  sx: {
                    "& .MuiMenuItem-root": {
                      padding: "8px 14px",
                    },
                  },
                },
              }}
            >
              <MenuItem value="ko">
                <MenuItemContent>
                  <LanguageFlag locale="ko" width={18} height={12} />
                  <span>한국어</span>
                </MenuItemContent>
              </MenuItem>
              <MenuItem value="en">
                <MenuItemContent>
                  <LanguageFlag locale="en" width={18} height={12} />
                  <span>English</span>
                </MenuItemContent>
              </MenuItem>
              <MenuItem value="zh">
                <MenuItemContent>
                  <LanguageFlag locale="zh" width={18} height={12} />
                  <span>中文</span>
                </MenuItemContent>
              </MenuItem>
              <MenuItem value="ja">
                <MenuItemContent>
                  <LanguageFlag locale="ja" width={18} height={12} />
                  <span>日本語</span>
                </MenuItemContent>
              </MenuItem>
              <MenuItem value="vi">
                <MenuItemContent>
                  <LanguageFlag locale="vi" width={18} height={12} />
                  <span>Tiếng Việt</span>
                </MenuItemContent>
              </MenuItem>
              <MenuItem value="es">
                <MenuItemContent>
                  <LanguageFlag locale="es" width={18} height={12} />
                  <span>Español</span>
                </MenuItemContent>
              </MenuItem>
            </LanguageSelectMUI>
          </LanguageSelectFormControl>
          </LanguageSelectWrapper>
        )}

        <HeaderUser
          onNext={handleClick}
          systemSetting={systemSetting("admin")}
        />

        <IconWrapper2 onClick={hadleLogout}>
          <LogOutIcon />
          <HeaderFont>{t.navigation.logout}</HeaderFont>
        </IconWrapper2>
      </OptionWrapper>

      {/* 마이페이지 모달 */}
      <UserDetailModal
        idx={idx}
        open={open}
        onPressNo={userModalonPressNo}
        setDetailData={setDetailData}
        onClickModify={onClickModify}
        isMyPage={true}
        systemSetting={systemSetting("admin")}
      />
      {/* 정보수정하기 모달 */}
      <UserModifyModal
        open={openModify}
        data={detailData}
        idx={idx}
        onPressNo={onPressNoModify}
        isMyPage={true}
        systemSetting={systemSetting("admin")}
      />
    </Box>
  );
};

const HeaderItems = styled.ul`
  display: flex;
  justify-content: space-between;
  margin: 0px 20px;
  flex-grow: 1;

  
`;

const LogoWrapper = styled.button`
  cursor: pointer;
`;

const HeaderItemContainer = styled.div<{ active?: boolean; emptyCircle?: boolean }>`
  position: relative;
  font-weight: 700;
  font-size: 15px;
  line-height: 18px;
  padding: 25px 0px;
  text-align: center;
  cursor: pointer;
  &:last-child {
    margin-right: 0;
  }

  color: ${({ active }) =>
    active ? theme.statusColor.MAIN : theme.color.neutral_600};

  > svg {
    path {
      fill: ${({ active }) =>
      active ? theme.statusColor.MAIN : theme.color.neutral_600};
    }

    circle {
      fill: ${({ emptyCircle, active }) =>
        emptyCircle || active
          ? theme.statusColor.MAIN
          : theme.color.neutral_600};
    }
  }

  &:hover {
    color: ${({ active }) =>
      active ? theme.statusColor.MAIN : theme.statusColor.MAIN};

      > svg {
        path {
          fill: ${({ active }) =>
          active ? theme.statusColor.MAIN : theme.statusColor.MAIN};
        }

        circle {
          fill: ${({ emptyCircle, active }) =>
            emptyCircle || active
              ? theme.statusColor.MAIN
              : theme.statusColor.MAIN};
        }
      }

    div {
      // 호버시
      max-height: 50rem;
      box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);
    }
  }
  
`;

const HeaderItemBox = styled.div`
  // 내비 메뉴 드롭다운 박스
  position: absolute;
  z-index: 150;
  width: 180px;
  background-color: white;
  left: -10px;
  top: 100%;
  text-align: center;
  border-radius: 15px;

  // 숨김상태
  overflow-y: hidden;
  max-height: 0px;
  padding: 0px;
  transition: 0.3s;
`;

const HeaderItem = styled.li<{ active: boolean; isDrop?: boolean; emptyCircle?: boolean}>`
  font-weight: 700;
  font-size: 15px;
  line-height: 18px;
  color: ${({ active }) =>
    active ? theme.statusColor.MAIN : theme.color.neutral_600};
  padding: 25px 0px;
  position: relative;
  cursor: pointer;
  
  svg {
    path {
      fill: ${({ active }) =>
      active ? theme.statusColor.MAIN : theme.color.neutral_600};
    }

    circle {
      fill: ${({ emptyCircle, active }) =>
        emptyCircle || active
          ? theme.statusColor.MAIN
          : theme.color.neutral_600};
    }
  }

  &:hover {
    color: ${({ active }) =>
      active ? theme.statusColor.MAIN : theme.statusColor.MAIN};
    
    svg {
      path {
        fill: ${({ active }) =>
        active ? theme.statusColor.MAIN : theme.statusColor.MAIN};
      }
    }

    svg {
      circle {
        fill: ${({ emptyCircle, active }) =>
          emptyCircle || active
            ? theme.statusColor.MAIN
            : theme.statusColor.MAIN};
      }
    }
  }
`;

const OptionWrapper = styled.div`
  display: flex;
  gap: 42px;
  align-items: center;
  flex: 1;
  justify-content: flex-end;
  flex-shrink: 0;
  min-width: 220px;
`;

const IconWrapper2 = styled.button`
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 7px;
  &:hover span {
    color: ${theme.statusColor.MAIN};
  }
  &:hover svg path {
    fill: ${theme.statusColor.MAIN};
  }
`;

const HeaderFont = styled.span`
  font-weight: 400;
  font-size: 13px;
  line-height: 15px;
  color: ${theme.color.neutral_400};
  cursor: pointer;
`;

const LanguageSelectWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

const LanguageSelectFormControl = styled(FormControl)`
  && {
    min-width: 50px;
    
    @media (max-width: ${theme.screen.md}px) {
      min-width: 45px;
    }
  }
`;

const LanguageSelectDisplay = styled.div`
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  pointer-events: none;
  z-index: 2;
`;

const MenuItemContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const LanguageSelectMUI = styled(Select<Locale>)`
  && {
    height: 28px;
    
    .MuiOutlinedInput-notchedOutline {
      border-color: ${theme.color.neutral_300};
      border-radius: 4px;
    }
    
    &:hover .MuiOutlinedInput-notchedOutline {
      border-color: ${theme.color.neutral_400};
    }
    
    &.Mui-focused .MuiOutlinedInput-notchedOutline {
      border-color: ${theme.statusColor.MAIN};
    }
    
    @media (max-width: ${theme.screen.md}px) {
      .MuiSelect-select {
        padding-left: 28px !important;
      }
    }
  }
`;

const Button = styled.button`
  color: inherit;
  font-size: inherit;
  font-weight: inherit;
`;

const NavText = styled.span`
  margin-left: 5px;
  font-weight: 700;
  font-size: 15px;
  line-height: 18px;
  padding: 25px 0px;
  position: relative;
  cursor: pointer;
`;

export default TopNav;
